var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WBase',{staticClass:"webjet-graffiti"},[_c('WHeader'),_c('WExpand',[_c('WContent',[(_vm.component)?_c(_vm.component,{ref:"editor",tag:"component"}):_vm._e(),_c('WChilds')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }